<cache-date></cache-date>

<br />

<ng-container>
	<div class="row">
		<div class="col-md-12">
			<button type="submit" class="btn btn-outline-dark" (click)="banSitesByList()">List for ban</button>
			&nbsp;
			<button type="button" class="btn btn-outline-dark" (click)="checkForDivly()">Check for Divly</button>
		</div>
	</div>

	<hr/>

	<!--Поиск-->
	<div class="row">
		<div class="col-md-12">
			<div id="js-filter">
				<form id="js-ul-support-filter" class="form-inline2 js-ul-support-group-scope" ng-submit="applyFilter()">
					<div class="row">
						<div class="col-md-3" *ngFor="let f of filters">
							<div class="form-check form-check-inline">
								<input class="form-check-input" type="radio" name="filter_type" value="{{f}}" [(ngModel)]="typeFilter"/>
								<label class="form-check-label">{{f}}</label>
							</div>

							<div class="form-group">
								<label class="control-label"></label>
								<input type="text" [(ngModel)]="filterSearch[f]" [name]="'filter_' + f" (focus)="typeFilter = f" class="form-control" placeholder="{{f}}" [sextant]="'filter_' + f"/>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-3">
							<button type="submit" id="js-ul-apply" class="btn btn-outline-dark" (click)="applyFilter()">Поиск</button>
							&nbsp;
							<button type="button" id="js-ul-reset" class="btn btn-outline-dark" (click)="resetFilter()">Сбросить</button>
						</div>
						<div class="col-md-3">
							<div class="form-check form-check-inline">
								<input class="form-check-input" type="checkbox" name="accurateSiteSearch" [checked]="filterSearch.accurateSiteSearch" [(ngModel)]="filterSearch.accurateSiteSearch">
								<label class="form-check-label">Точное совпадение</label>&nbsp;<span class="badge badge-pill badge-info" ngbTooltip="Действует на site и invoiceNumber">?</span>
							</div>
						</div>
						<div class="col-md-2">
							<div class="btn-group btn-group-sm" role="group" aria-label="Кластер">
								<button	*ngFor="let cluster of [1, 2]" type="button" [class]="supportService.cluster === cluster ? 'btn btn-dark' : 'btn btn-outline-dark'" (click)="setCluster(cluster)">
									{{ 'adminstat.common.clusters.' + cluster | translate }}
								</button>
							</div>
						</div>
						<div class="col-md-1">
							<loading [isLoad]="searchInProgress"></loading>
						</div>
						<div class="col-md-3"></div>
					</div>
				</form>
			</div>
		</div>
	</div>

	<hr/>
	
	<br/>

	<!--Пользовательская информация-->
	<div class="row">
		<div class="col-md-12">
			<loading [isLoad]="userInProgress"></loading>
			
			<div class="row" *ngIf="user != null">
				<div class="col-md-12">
					<h3>
						{{ 'adminstat.support.support.User info' | translate }}
					</h3>
					
					<table class="table">
						<thead>
							<tr>
								<th>
									{{ 'adminstat.common.User' | translate }}
								</th>
								
								<th>
									<span
										class="badge"
										[ngClass]="user.pro ? 'badge-success' : 'badge-secondary'"
									>
										{{'adminstat.support.support.Pro' | translate }}
									</span>
								</th>
								
								<th>
									{{ 'adminstat.support.support.Premium templates' | translate }}
								</th>
								
								<th>
									{{ 'adminstat.support.support.Experiments' | translate }}
								</th>
								
								<th>
									{{ 'adminstat.support.support.Dates' | translate }}
								</th>
							</tr>
						</thead>
						
						<tbody>
							<tr>
								<td>
									<ul class="list-group">
										<li class="list-group-item">
											<span class="badge badge-pill badge-light">
												{{ user._id }}
											</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											Email:
											<span class="badge badge-pill badge-info">
												{{ user.email }}
											</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.mails.mailer.confirm' | translate }}:
											
											<span class="badge badge-pill badge-info">
												{{ user.isConfirm | yesno }}
											</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{ 'adminstat.common.is hardbounce' | translate }}:
											
											<div class="custom-control custom-checkbox">
												<input
													type="checkbox"
													class="custom-control-input"
													id="hardbounceCheckBox"
													value="true"
													[(ngModel)]="user.hardbounce"
													[ngModelOptions]="{standalone: true}"
													(change)="changeHardboundStatus($event)"
												/>
												<label class="custom-control-label" for="hardbounceCheckBox"></label>
											</div>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.login' | translate }}:
											
											<span class="badge badge-pill badge-secondary">
												{{ user.username }}
											</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											Валюта:
											<br>
											<span class="badge badge-pill badge-info">
												{{ user.currency }}
											</span>
											&nbsp;
											<button
												type="button"
												class="btn btn-outline-primary btn-sm"
												(click)="runUserAction('changeCurrency')"
											>
												<i class="fa fa-pen"></i>
											</button>
										</li>
	
										<li class="list-group-item d-flex justify-content-between align-items-center">
											Affiliate:
	
											<span
												class="badge badge-pill"
												[ngClass]="user.affiliate != null ? 'badge-info' : 'badge-secondary'"
											>
												{{ user.affiliate || '—' }}
											</span>
										</li>
	
										<li class="list-group-item d-flex justify-content-between align-items-center">
											<button
												type="button"
												class="btn btn-primary"
												(click)="showReRegInfo(user)"
												[disabled]="user.countReReg === 0"
											> 
												Перереги
												<span class="badge badge-secondary">
													{{ user.countReReg }}
												</span>
											</button>
										</li>
										
										<li
											class="list-group-item"
											*ngIf="user.isExcluded"
										>
											<span class="badge badge-warning">Входит в фильтр статистики "Исключен"</span>
										</li>
									</ul>
								</td>
	
								<td>
									<button
										*ngIf="authService.isAllowResource('admin')"
										class="btn btn-mini"
										data-row-selector=".js-ul-user-row"
										[ngClass]="user.pro ? 'btn-danger' : 'btn-success'"
										(click)="runUserAction('spu')"
									>
										{{ (user.pro ? 'all.remove' : 'adminstat.support.support.appoint') | translate }}
									</button>
									
									<span
										*ngIf="!authService.isAllowResource('admin')">
										{{ (user.pro ? 'adminstat.common.Yes' : 'adminstat.common.No') | translate }}
									</span>
								</td>
	
								<td>
									<p *ngIf="authService.isAllowResource('support')">
										<button
											class="btn btn-mini btn-success w-100p"
											(click)="runUserAction('sptu')"
										>
											{{ 'adminstat.support.support.install' | translate }}
										</button>
									</p>
									
									<ng-template
										[ngIf]="user.tariffFeaturesData.premiumTemplates && user.tariffFeaturesData.premiumTemplates.length"
									>
										<p
											*ngFor="let premiumTemplate of user.tariffFeaturesData.premiumTemplates"
											class="small"
										>
											{{ premiumTemplate }}
										</p>
									</ng-template>
								</td>
	
								<td>
									<ng-container *ngIf="(user.experiments | keys).length > 0">
										<p class="ul-margin-bottom-xsm" *ngFor="let experiment of user.experiments | keys">
											{{ 'adminstat.filterForm.' + experiment | translate }}:
											<br>
											<span class="badge badge-pill badge-secondary">
												{{ user.experiments[experiment] }}
											</span>
										</p>
									</ng-container>
								</td>
	
								<td>
									<p class="ul-margin-bottom-xsm">
										{{'adminstat.support.support.reg' | translate }}:
										<br>
										<span class="badge badge-pill badge-primary">
											{{ user.created | date:"dd.MM.yyyy" }}
										</span>
									</p>
									
									<p class="ul-margin-bottom-xsm">
										{{'adminstat.support.support.last auth' | translate }}:
										<br>
										<span class="badge badge-pill badge-success">
											{{ user.lastAuthDate | date:"dd.MM.yyyy" }}
										</span>
									</p>
								</td>
							</tr>
						</tbody>
					</table>

					<table class="table">
						<thead>
							<tr>
								<th>
									{{ 'adminstat.support.support.Langs' | translate }}
								</th>
								
								<th>
									{{ 'adminstat.support.support.Locations' | translate }}
								</th>
								
								<th>
									{{ 'adminstat.support.support.IPs' | translate }}
								</th>
								
								<th>
									{{ 'adminstat.support.support.Phone' | translate }}
								</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>
									<p class="ul-margin-bottom-xsm">
										{{'adminstat.support.support.reg' | translate }}:
										<br>
										<span class="badge badge-pill badge-primary">
											{{ user.createdLang }}
										</span>
									</p>
									
									<p class="ul-margin-bottom-xsm">
										{{'adminstat.support.support.last auth' | translate }}:
										<br>
										<span class="badge badge-pill badge-success">
											{{ user.lastAuthLang }}
										</span>
									</p>
								</td>
								<td>
									<p class="ul-margin-bottom-xsm">
										{{'adminstat.support.support.reg' | translate }}:
										<br>
										<span class="badge badge-pill badge-primary">
											{{ user.createdCountry }}
										</span>
										<br>
										<span class="badge badge-pill badge-success">
											{{ user.createdCity }}
										</span>
									</p>
									
									<p class="ul-margin-bottom-xsm">
										{{'adminstat.support.support.last auth' | translate }}:
										<br>
										<span class="badge badge-pill badge-primary">
											{{ user.lastAuthCountry }}
										</span>
										<br>
										<span class="badge badge-pill badge-success">
											{{ user.lastAuthCity }}
										</span>
									</p>
								</td>
								<td>
									<p class="ul-margin-bottom-xsm">
										{{'adminstat.support.support.reg' | translate }}:
										<br>
										<span class="badge badge-pill badge-primary">
											{{ user.createdIP }}
										</span>
									</p>
									<p class="ul-margin-bottom-xsm">
										{{'adminstat.support.support.last auth' | translate }}:
										<br>
										<span class="badge badge-pill badge-success">
											{{ user.lastAuthIP }}
										</span>
									</p>
								</td>
								
								<td>
									<ng-template [ngIf]="user.phone">
										{{ 'adminstat.common.dashnoard' | translate }}:
										
										<a [href]="'tel:' + user.phone">{{ user.phone | phoneFormat }}</a>
										
										<hr/>
									</ng-template>
									
									<ng-template [ngIf]="user.phonesFromUser.length > 0">
										{{ 'adminstat.common.phone dashnoard history' | translate }}:
										
										<ul>
											<li *ngFor="let phone of user.phonesFromUser">
												<a [href]="'tel:' + phone">{{ phone | phoneFormat }}</a>
											</li>
										</ul>
										
										<hr>
									</ng-template>
									
									
									<ng-template [ngIf]="user.phonesFromSites.length > 0">
										<ngb-accordion #acc="ngbAccordion">
											<ngb-panel title="{{ 'adminstat.common.sites' | translate }} ({{user.phonesFromSites.length}})">
												<ng-template ngbPanelContent>
													<ul>
														<li *ngFor="let phone of user.phonesFromSites">
															<a [href]="'tel:' + phone">{{ phone | phoneFormat }}</a>
														</li>
													</ul>
												</ng-template>
											</ngb-panel>
										</ngb-accordion>
										
										<hr>
									</ng-template>
									
									<ng-template [ngIf]="user.phonesFromExternalData.length > 0">
										<ngb-accordion #acc="ngbAccordion">
											<ngb-panel
												title="{{ 'adminstat.common.external data' | translate }} ({{user.phonesFromExternalData.length}})">
												<ng-template ngbPanelContent>
													<ul>
														<li *ngFor="let phone of user.phonesFromExternalData">
															<a [href]="'tel:' + phone">{{ phone | phoneFormat }}</a>
														</li>
													</ul>
												</ng-template>
											</ngb-panel>
										</ngb-accordion>
									</ng-template>
								</td>
							</tr>
							
							<tr>
								<td colspan="4">
									<ng-template [ngIf]="authService.isAllowResource('admin') || authService.isAllowResource('billing')">
										<button
											class="btn btn-success"
											(click)="runUserAction('setUserRole')"
										>
											{{ 'adminstat.support.support.set role' | translate }}
										</button>
										&nbsp;
										<button
											class="btn btn-warning"
											(click)="runUserAction('rup')"
										>
											{{ 'adminstat.support.support.restore pass' | translate }}
										</button>
										&nbsp;
										<button
											class="btn btn-warning"
											(click)="runUserAction('sup')"
										>
											{{ 'adminstat.support.support.set pass' | translate }}
										</button>
										&nbsp;
									</ng-template>
									
									<button
										class="btn btn-danger"
										(click)="runUserAction('userBan')"
									>
											{{ (user.isBan ? 'adminstat.support.support.unblock' : 'adminstat.support.support.block') | translate }}
									</button>
									&nbsp;
									
									<button
										class="btn btn-info"
										(click)="runUserAction('setDivlyId')"
									>
										Divly
									</button>
									&nbsp;
									
									<span
										*ngIf="user.affiliates.Divly"
										class="badge badge-pill badge-info"
									>
										{{ user.affiliates.Divly.partnerId }}
									</span>
									
									<span
										*ngIf=" ! user.isExcluded"
										class="btn btn-danger"
									>
										<button
											class="btn btn-danger"
											(click)="runUserAction('exclude_from_stats')"
										>
											Добавить в фильтр статистики "Исключен"
										</button>
									</span>
								</td>
							</tr>
	
							<tr>
								<td colspan="4">
									<button
											class="btn btn-secondary"
											(click)="runUserAction('showSupportLogs')"
									>
										{{'adminstat.support.support.users action logs' | translate }}
									</button>
									&nbsp;
	
									<ng-template [ngIf]="authService.isAllowResource('admin') || authService.isAllowResource('billing')">
										<button
												class="btn btn-secondary"
												(click)="runUserAction('showSupportActionLogs')"
										>
											{{'adminstat.support.support.support action logs' | translate }}
										</button>
									</ng-template>
								</td>
							</tr>
							
							<tr>
								<td *ngIf="authService.isAllowResource('admin')" colspan="4">
									<a href="#collapseButtonNote" [attr.aria-expanded]="false" aria-controls="collapseButtonNote" (click)="$event.preventDefault(); isCollapsedButtonNote = !isCollapsedButtonNote;">{{'adminstat.support.support.Note' | translate }}:</a>
									<div id="collapseButtonNote" [ngbCollapse]="isCollapsedButtonNote">
										<textarea class="form-control" rows="5" [(ngModel)]="user.note">{{user.note}}</textarea>
										<button class="btn btn-mini btn-success" (click)="saveNote()">{{'adminstat.common.Save' | translate }}</button>
									</div>
								</td>
							</tr>
							
							<tr>
								<td colspan="4">
									<ngb-accordion #acc="ngbAccordion">
										<ngb-panel title="{{'adminstat.support.support.Show Referer info' | translate }}">
											<ng-template ngbPanelContent>
												<table class="table">
													<thead>
													<tr>
														<th>{{'adminstat.filterForm.refType' | translate }}</th>
														<th>{{'adminstat.filterForm.refGroup' | translate }}</th>
														<th>{{'adminstat.filterForm.refSource' | translate }}</th>
														<th>{{'adminstat.filterForm.referer' | translate }}</th>
														<th>{{'adminstat.filterForm.markType' | translate }}</th>
													</tr>
													</thead>
													<tbody>
													<tr *ngFor="let type of ['first', 'created', 'last', 'paid_first', 'paid_last']">
														<td>{{type}}</td>
														<td>{{user.referers[type].groupName}}</td>
														<td>{{user.referers[type].groupRef}}</td>
														<td>{{user.referers[type].referer}}</td>
														<td>
															<div style="max-width: 300px; display: block;">
																<table class="table">
																	<tr *ngFor="let item of getUTMData(user.referers[type].mark)">
																		<td>{{item.key}}</td>
																		<td>{{item.utm}}</td>
																	</tr>
																</table>
															</div>
														</td>
													</tr>
													</tbody>
												</table>
											</ng-template>
										</ngb-panel>
									</ngb-accordion>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>

	<!--Дополнительная информация-->
	<div class="row" *ngIf="apps.length > 0">
		<div class="col-md-12">
			<div class="row">
				<div class="col-md-12">
					<h3>
						{{'adminstat.support.support.Additional Information' | translate }}
					</h3>
					
					<table class="table">
						<thead>
							<tr>
								<th>{{'adminstat.support.support.avatar' | translate }}</th>
								<th>{{'adminstat.support.support.profile url' | translate }}</th>
								<th>{{'adminstat.support.support.User info' | translate }}</th>
								<th>{{'adminstat.common.age' | translate }}</th>
								<th>{{'adminstat.support.support.gender' | translate }}</th>
								<th>{{'adminstat.support.support.location' | translate }}</th>
							</tr>
						</thead>
						
						<tbody>
							<tr *ngFor="let app of apps">
								<td>
									<img *ngIf="app.avatarUrl" [src]="app.avatarUrl" width="50px" height="50px"/>
								</td>
								
								<td>
									<a *ngIf="app.profileUrl" target="_blank" rel="noreferrer" [href]="app.profileUrl">{{app.appId}}</a>
									<span *ngIf="!app.profileUrl">{{app.appId}}</span>
									{{app.isSource ? 'registered' : ''}}
								</td>
								
								<td>
									{{app.email || ''}}
									<br>
									{{app.userName}}
								</td>
								
								<td>
									{{app.birthday ? getAge(app.birthday) : ''}}
								</td>
								
								<td>
									{{ app.gender }}
								</td>
								
								<td>
									{{app.country}}<br>
									{{app.city}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	
	<!--Сайты-->
	<div class="row">
		<div class="col-md-12">
			<loading [isLoad]="sitesInProgress"></loading>
			
			<div class="row" *ngIf="user != null && sites.length > 0">
				<div class="col-md-10">
					<h3>
						Сайтов всего {{ totalSiteCount }},
						загружено
						<span [sextant]="'sites.length'">
							{{ sites.length }} / {{ sitesOnPage }}
						</span>
					</h3>
				</div>
				
				<div class="col-md-10">
					<ngb-pagination
						[collectionSize]="totalSiteCount"
						[pageSize]="sitePageSize"
						[(page)]="filterSearch.sitePage"
						[boundaryLinks]="true"
						[maxSize]="10"
						(pageChange)="onPageChange($event)"
					></ngb-pagination>
				</div>
				
				<div class="col-md-2">
					<select
						class="form-control"
						[(ngModel)]="sitePageSize"
					>
						<option
							*ngFor="let i of [10, 50, 100]"
							[ngValue]="i"
						>
							{{ i }}
						</option>
					</select>
				</div>
				
				<div class="col-md-12">
					<table class="table">
						<thead>
							<tr>
								<th>Платежная информация</th>
								<th>Информация о сайте</th>
								<th>Даты</th>
								<th>Управление</th>
							</tr>
						</thead>
						
						<tbody class="js-site">
							<tr
								*ngFor="let site of sites; let i = index"
								class="table-{{(site._foundedByInvoiceNumber ? 'default' : (site.isBlock ? 'warning' : (site.isBan ? 'danger' : 'default')))}}"
							>
								<td>
									<ul class="list-group">
										<li
											*ngIf="site.status == -1"
											class="list-group-item d-flex justify-content-between align-items-center"
										>
											<span class="badge badge-pill badge-danger">
												{{ 'adminstat.support.support.didnt go to constructor' | translate }}
											</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.Freemium' | translate }}
											
											<button
												type="button"
												class="btn btn-sm"
												[ngClass]="site.inFreemiumMode ? 'btn-success' : 'btn-danger'"
												(click)="runSiteAction('sf', site._id)"
											>
												{{ site.inFreemiumMode | yesno }}
											</button>
										</li>
										
										<ng-template [ngIf]="site.status != -1">
											<li class="list-group-item d-flex justify-content-between align-items-center">
												{{'adminstat.support.support.payment' | translate }}
												
												<span
													class="badge badge-pill badge-{{paidStatuses[site.sitePaidStatus].label}}"
												>
													{{ paidStatuses[site.sitePaidStatus].i18n }}
												</span>
												
												<button
													*ngIf="site.hasPaid && !['paid', 'paidExpired'].includes(site.sitePaidStatus)"
													type="button"
													(click)="runSiteAction('billingDetail', site._id)"
													class="btn btn-outline-dark btn-sm"
												>
													<i class="fa fa-eye" aria-hidden="true"></i>
												</button>
											</li>
											
											<ng-template [ngIf]="['paid', 'paidExpired'].includes(site.sitePaidStatus)">
												<li
													class="list-group-item d-flex justify-content-between align-items-center"
												>
													Тариф
													
													<span class="badge badge-pill badge-secondary">
														{{ site.tariffId }}
													</span>
													
													<button
														*ngIf="site.hasPaid"
														type="button"
														(click)="runSiteAction('billingDetail', site._id)"
														class="btn btn-outline-dark btn-sm"
													>
														<i class="fa fa-eye" aria-hidden="true"></i>
													</button>
												</li>
											</ng-template>
											
											<li
												*ngIf="site.recurrentProfiles.length || site.lastDisableRec"
												class="list-group-item d-flex justify-content-between align-items-center"
											>
												Подписка
												
												<ng-template [ngIf]="site.recurrentProfiles.length">
													<span
														class="badge badge-pill badge-secondary"
														[title]="site.recurrentProfiles.slice(1).join(',')"
													>
														{{ site.recurrentProfiles[0] }}
													</span>
													
													<button
														type="button"
														class="btn btn-outline-primary btn-sm"
														(click)="runSiteAction('editRecurrent', site._id)"
													>
														<i class="fa fa-pen"></i>
													</button>
													
													<button
														type="button"
														class="btn btn-outline-danger btn-sm"
														(click)="runSiteAction('disableRecurrentProfile', site._id)"
													>
														<i class="fa fa-times-circle"></i>
													</button>
												</ng-template>
												
												<ng-template [ngIf]="site.lastDisableRec">
													<span class="badge badge-pill badge-danger">
														<i class="fa fa-ban"></i>
														{{ site.lastDisableRec }}
													</span>
												</ng-template>
											</li>
											
											<li class="list-group-item d-flex justify-content-between align-items-center">
												Divly-метка
												
												<button
													type="button"
													(click)="runSiteAction('setDivlyLabel', site._id)"
													class="btn btn-sm"
													[ngClass]="site.isUber ? 'btn-success' : 'btn-danger'"
												>
													{{ site.isUber | yesno }}
												</button>
											</li>

											<li class="list-group-item d-flex justify-content-between align-items-center">
												{{ 'adminstat.filterForm.isSeoUber' | translate }}

												<button
														type="button"
														(click)="runSiteAction('seoUber', site._id)"
														class="btn btn-sm"
														[ngClass]="site.isSeoUber ? 'btn-success' : 'btn-danger'"
												>
													{{ site.isSeoUber | yesno }}
												</button>
											</li>
											
											<li class="list-group-item d-flex justify-content-between align-items-center">
												{{ 'adminstat.support.support.sites action logs' | translate }}
												
												<button
													type="button"
													class="btn btn-outline-dark btn-sm"
													(click)="runSiteAction('showSiteLogs', site._id)"
												>
													<i class="fa fa-folder-open" aria-hidden="true"></i>
												</button>
											</li>
											
											<li
												*ngIf="false"
												class="list-group-item d-flex justify-content-between align-items-center">
												Хронология
												
												<button
													type="button"
													class="btn btn-outline-dark btn-sm"
													(click)="runSiteAction('showSiteHistory', site._id)"
												>
													<i class="fa fa-folder-open" aria-hidden="true"></i>
												</button>
											</li>
										</ng-template>
									</ul>
								</td>
								
								<td>
									<ul class="list-group">
										<li class="list-group-item d-flex justify-content-between align-items-center">
											<span class="badge badge-pill badge-light">{{site._id}}</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.common.Status' | translate }}
											<span class="badge badge-pill badge-success" [ngStyle]="{'background-color': getSiteStatusStyle(site)}">{{'adminstat.support.support.' + getSiteStatus(site) | translate }}</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.primaryDomain' | translate }}
											<a target="_blank" rel="noreferrer" [href]="'http://' + site.domainUrl">{{site.domainUrl}}</a>
										</li>
										
										<li *ngIf="site.domainUrl != site.techUrl" class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.techUrl' | translate }}
											<a target="_blank" rel="noreferrer" [href]="'http://' + site.techUrl">{{site.techUrl}}</a>
										</li>
										
										<li *ngIf="site.domains.length > 0 || site.domainsHistory.length > 0" class="list-group-item d-flex justify-content-between">
											{{'adminstat.common.Domains' | translate }}&nbsp;
											<ul class="list-group">
												<li class="list-group-item" *ngFor="let domain of site.domains">
													<a target="_blank" rel="noreferrer" [href]="'http://' + domain">{{domain}}</a>
												</li>
												<li class="list-group-item" *ngFor="let domain of site.domainsHistory">
													<a target="_blank" rel="noreferrer" [href]="'http://' + domain.url">{{domain.url}}</a>
													<br/>
													<span class="badge badge-pill badge-light">{{domain.status}}</span>
													{{domain.d}}
												</li>
											</ul>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.dashboard' | translate }}
											<a
												class=" ul-status ul-dashboard"
												[href]="'https://' + (site._source === 1 ? '' : 'c2.') + 'ukit.com/sites/url/' + site.url + '/dashBoard'"
												target="_blank"
											>
												<i class="fa fa-tachometer-alt" aria-hidden="true"></i>
											</a>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.template' | translate }}
											<span class="badge badge-pill badge-light">{{site.templateId}}</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.filterForm.category' | translate }}
											<span class="badge badge-pill badge-light">{{site.realCategoryId}}</span>
										</li>

										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'Мультияз'}}
											<div [ngSwitch]="(site.isMultilangParent ? 1 : (site.multilangParentId == null ? 2 : 3))">
												<ng-template [ngSwitchCase]="1">
													<span class="badge badge-pill badge-secondary">Оригинал</span>
												</ng-template>
												<ng-template [ngSwitchCase]="2">
													<button
															type="button"
															class="btn btn-outline-dark btn-sm"
															(click)="runSiteAction('setMultilangClone', site._id)"
													>
														Нет
													</button>
												</ng-template>
												<ng-template [ngSwitchCase]="3">
													<button
															type="button"
															class="btn btn-outline-dark btn-sm"
															(click)="runSiteAction('setMultilangClone', site._id)"
													>
														Да
													</button>
												</ng-template >
											</div>
										</li>
									</ul>
									
									<ng-template [ngIf]="!site.markForRemovalAt">
										<a
											href="#collapseSiteMap{i}"
											[attr.aria-expanded]="!isCollapsedSiteMap[i]"
											aria-controls="collapseSiteMap"
											(click)="$event.preventDefault(); isCollapsedSiteMap[i] = !isCollapsedSiteMap[i];"
										>{{'adminstat.support.support.sitemap' | translate }}</a>
										
										(страниц на сайте: {{ site.pageCount }} )
										
										<div id="collapseSiteMap{i}" [ngbCollapse]="isCollapsedSiteMap[i]">
											<div class="list-group">
												<a
													target="_blank"
													[href]="'https://ukit.com/preview/' + site.url + '/' + page"
													class="list-group-item"
													*ngFor="let page of site.pages"
												>
													{{page}}
												</a>
											</div>
										</div>
									</ng-template>
								</td>
								<td>
									<ul class="list-group">
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.dateCreate' | translate }}
											<span class="badge badge-pill badge-light">{{site.dateCreate | date:"dd.MM.yyyy"}}</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.dateEdit' | translate }}
											<span class="badge badge-pill badge-light">{{site.dateEdit | date:"dd.MM.yyyy"}}</span>
										</li>
										
										<li *ngIf="site.datePublished" class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.datePublished' | translate }}
											<span class="badge badge-pill badge-light">{{site.datePublished | date:"dd.MM.yyyy"}}</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.dateTrialStart' | translate }}
											<span class="badge badge-pill badge-light">{{site.dateTrialStart | date:"dd.MM.yyyy"}}</span>
										</li>
										
										<li *ngIf="site.markForRemovalAt && site.markForRemovalAt !== ''" class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.markForRemovalAt' | translate }}
											<span class="badge badge-pill badge-light">{{site.markForRemovalAt | date:"dd.MM.yyyy"}}</span>
										</li>
										
										<li
											*ngIf="['trial', 'trialExpired'].includes(site.sitePaidStatus)"
											class="list-group-item d-flex justify-content-between align-items-center"
										>
											{{'adminstat.support.support._trialExpiration' | translate }}
											
											<span class="badge badge-pill badge-light">
												{{site._trialExpiration ? site._trialExpiration : '&mdash;'}}
											</span>
										</li>
										
										<li
											*ngIf="['paid', 'paidExpired'].includes(site.sitePaidStatus)"
										    class="list-group-item d-flex justify-content-between align-items-center"
										>
											{{'adminstat.support.support._paidExpiration' | translate }}
											
											<span class="badge badge-pill badge-light">
												{{site._paidExpiration ? site._paidExpiration : '&mdash;'}}
											</span>
										</li>
										
										<li class="list-group-item d-flex justify-content-between align-items-center">
											{{'adminstat.support.support.shop trial' | translate }}
											
											<span class="badge badge-pill badge-light">
												{{site.shopTrialExpiration == -1 ? '&mdash;' : site.shopTrialExpiration}}
											</span>
										</li>
									</ul>
								</td>
								<td>
									<ng-template [ngIf]="!site.isBan && !site.markForRemovalAt">
										<ng-template ngFor let-action [ngForOf]="billingButtonsActions">
											<ng-template [ngIf]="billingButtons[action].condition.equals.indexOf(site[billingButtons[action].condition.value]) !== -1 || (action=='atts' && site.paidType == 'paid')">
												<button class="btn btn-mini btn-block" [ngClass]="'btn-' + billingButtons[action].class" (click)="runSiteAction(action, site._id)">{{billingButtons[action].text}}</button>
											</ng-template>
										</ng-template>
									</ng-template>
	
									<ng-template [ngIf]="!site.isBan">
										<button *ngIf="site.markForRemovalAt" class="btn btn-mini btn-warning btn-block" title="{{'adminstat.support.support.restore' | translate }}" (click)="runSiteAction('siteRestore', site._id)">{{'adminstat.support.support.restore' | translate }}</button>
	
										<button class="btn btn-mini btn-warning btn-block" (click)="runSiteAction('siteBlock', site._id)">{{(site.isBlock ? 'adminstat.support.support.unblock' : 'adminstat.support.support.block') | translate }}</button>
										<button class="btn btn-mini btn-secondary btn-block" (click)="runSiteAction('chso', site._id)">{{'adminstat.support.support.change owner' | translate }}</button>
										
										<a href="#collapseButtonsMore{i}" [attr.aria-expanded]="!isCollapsedButtonsMore[i]" aria-controls="collapseButtonsMore" (click)="$event.preventDefault(); isCollapsedButtonsMore[i] = !isCollapsedButtonsMore[i];">{{'widgets.mainmenu.more' | translate }}</a>
										
										<div id="collapseButtonsMore{i}" [ngbCollapse]="isCollapsedButtonsMore[i]">
											<button class="btn btn-secondary btn-block" (click)="runSiteAction('siteClone', site._id)">Дублировать</button>
											<button class="btn btn-secondary btn-block" (click)="runSiteAction('csl', site._id)">{{'adminstat.support.support.change lang' | translate }}</button>
											<button class="btn btn-warning btn-block" (click)="runSiteAction('breakPublish', site._id)">Прервать публикацию</button>
											<button class="btn btn-outline-dark btn-block" (click)="runSiteAction('siteAndUserActivity', site._id)">Информация о сайте и владельце</button>
											<button class="btn btn-outline-warning btn-block" (click)="runSiteAction('fixWidgets', site._id)">Починить виджеты</button>
											<button class="btn btn-outline-info btn-block" (click)="runSiteAction('siteFiles', site._id)">Файлы</button>

											<button
												*ngIf="true"
												class="btn btn-mini btn-danger btn-block"
												title="{{ 'adminstat.promopult.title' | translate }}"
												(click)="runSiteAction('promopult', site._id)"
											>
												{{ 'adminstat.promopult.title' | translate }}
											</button>
										</div>
									</ng-template>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</ng-container>
